/** Element status for any state changes
    @readonly
    @enum {number}
*/
export const STATUS = {
    DEFAULT: 0,
    OPEN: 1,
    CLOSED: 0,
    LOCKED: 0
};
